import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { NgIf, AsyncPipe } from '@angular/common';
import { SignalRService } from 'app/services/signal-r.service';
import { filter, map, merge, of, repeat, ReplaySubject, skip, switchMap, takeUntil, takeWhile, tap, timer } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FuseAlertModule } from '@fuse/components/alert';

@Component({
  selector: 'tm-signal-r-error-connection',
  standalone: true,
  imports: [NgIf, AsyncPipe, FuseAlertModule],
  templateUrl: './signal-r-error-connection.component.html',
  styleUrls: ['./signal-r-error-connection.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SignalRErrorConnectionComponent implements OnInit {
  private readonly signalRService = inject(SignalRService);
  private readonly snackBar = inject(MatSnackBar);
  readonly timer$ = new ReplaySubject<number>(1);
  readonly isConnected$ = merge(of(true), this.signalRService.isConnected$, this.signalRService.reconnect$.pipe(map(() => true))).pipe(
  );

  private readonly isDisconnect$ = this.signalRService.isConnected$.pipe(
    filter(isConnected => !isConnected),
  );

  private readonly destroy$ = this.signalRService.isConnected$.pipe(
    filter(isConnected => isConnected),
  );

  reconnect() {
    this.signalRService.reconnect();
  }

  ngOnInit(): void {
    this.signalRService.isConnected$.pipe(
      skip(1)
    ).subscribe((isConnected) => {
      if (isConnected)
        this.snackBar.open('Connection restored!', '', { duration: 2000 })
    });
    this.isDisconnect$.pipe(
      switchMap(() => timer(0, 1000)),
      takeWhile((v) => v <= this.signalRService.timeoutReconnect),
      takeUntil(this.destroy$),
      repeat({
        delay: () => this.isDisconnect$
      }),
      tap((v) => this.timer$.next(this.signalRService.timeoutReconnect - v)),
    ).subscribe();
  }
}